export default function(variables) {
  for (const cssVar in variables) {
    document.documentElement.style.setProperty(
      `--${cssVar}`,
      variables[cssVar] ?? null
    );
  }
}
